export default __webpack_public_path__ + "static/media/case-li4.53304785.png";